export default __webpack_public_path__ + "static/media/Resources.0b29912b.svg";